'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of navigate web
 */ const NavigateWeb = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "19.9531",
                y: "31.6211",
                width: "63.9459",
                height: "37.2433",
                rx: "3.46892",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.9492 62.1216V65.4005C19.9492 67.3164 21.5023 68.8695 23.4181 68.8695H80.4262C82.3421 68.8695 83.8952 67.3164 83.8952 65.4005V62.1216H19.9492Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.1602",
                y: "68.8594",
                width: "19.6757",
                height: "6.04325",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "35.2734",
                y: "74.7676",
                width: "33.3081",
                height: "1.68649",
                rx: "0.843243",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M51.9629 37.5293C46.3146 37.5293 41.7344 42.1081 41.7344 47.7578C41.7344 53.4076 46.3132 57.9864 51.9629 57.9864C57.6127 57.9864 62.1915 53.4076 62.1915 47.7578C62.1915 42.1081 57.6127 37.5293 51.9629 37.5293ZM56.0948 44.5198L52.7696 52.8651C52.5237 53.4835 51.6312 53.4272 51.4626 52.7836L50.6278 49.5849C50.5645 49.3431 50.3762 49.1548 50.1345 49.0916L46.9358 48.2568C46.2921 48.0895 46.2373 47.1971 46.8543 46.9497L55.1996 43.6245C55.7617 43.4011 56.3183 43.9576 56.0948 44.5198Z",
                fill: theme.ds5.asset[assetColor]["500"]
            })
        ]
    });
};

exports.NavigateWeb = NavigateWeb;
//# sourceMappingURL=NavigateWeb.cjs.map
